import gql from 'graphql-tag';

export default gql`
  query getProductFeedbacks($productId: String!, $rating: [Int], $pagination: Pagination!) {
    getProductFeedbacks(productId: $productId, rating: $rating, pagination: $pagination) {
      totalResults
      totalPage
      data {
        id
        rating
        userName
        userImageUrl
        orderDate
        createdDate
        comment
        medias {
          url
          type
          name
        }
      }
    }
  }
`;
